import { FormattedMessage } from 'react-intl'
import Link from 'components/shared/Link'
import { useState } from 'react'
import ZonesModal from 'routes/Tickets/sections/ZonesDescription/components/ZonesModal'
import Icon from 'components/shared/Icon'
import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { ZonesModalTriggerWrapper } from './styles'
import { usePromotions } from 'components/shared/Promotions/utils/usePromotions'

interface ZonesModalTriggerProps {
    'data-testid'?: string
}

const ZonesModalTrigger = ({
    'data-testid': testId,
}: ZonesModalTriggerProps) => {
    const [isModalOpened, setIsModalOpened] = useState<boolean>(false)
    const { isDarkThemeForTickets } = usePromotions()

    const handleOpenModal = () => setIsModalOpened(true)
    const handleCloseModal = () => setIsModalOpened(false)

    return (
        <>
            <ZonesModalTriggerWrapper mt={[12, 16]} pt={8} pb={8} isFullWidth>
                <Text
                    variant="body"
                    color={
                        isDarkThemeForTickets
                            ? 'grayscale_200'
                            : 'grayscale_900'
                    }
                >
                    <FormattedMessage
                        id="zones.modal.open_trigger"
                        defaultMessage="Pierwszy raz? <link>Poznaj strefy Suntago</link>"
                        values={{
                            link: (chunks: string[]) => (
                                <Box
                                    style={{ display: 'inline-flex' }}
                                    direction="row"
                                    align="center"
                                    as="span"
                                    gap={2}
                                >
                                    <Link
                                        variant={
                                            isDarkThemeForTickets
                                                ? 'primary'
                                                : 'secondary'
                                        }
                                        textVariant="body"
                                        icon={null}
                                        onClick={handleOpenModal}
                                        data-testid={testId}
                                        isUnderlined
                                    >
                                        {chunks}
                                    </Link>
                                    <Icon
                                        variant="guidebook"
                                        size={20}
                                        {...(isDarkThemeForTickets && {
                                            color: 'primary_500',
                                        })}
                                    />
                                </Box>
                            ),
                        }}
                    />
                </Text>
            </ZonesModalTriggerWrapper>
            {isModalOpened && (
                <ZonesModal
                    isOpened={isModalOpened}
                    closeModal={handleCloseModal}
                />
            )}
        </>
    )
}

export default ZonesModalTrigger
